// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getColor from "@insite/mobius/utilities/getColor";
import { listStyles } from "@monsma/Overrides/Widgets/Brand/BrandGallery";
import { css } from "styled-components";

listStyles.titleText = {
    variant: "h2",
    transform: "inherit",
    css: css`
        border-width: 20px;
        text-align: center;
        line-height: 34px;
        color: ${getColor("common.ui1")};
    `,
};

listStyles.imageContainer = {
    css: css`
        justify-content: flex-start;
    `,
};
